/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Das28EditionFormComponent from "parog-web/components/abstract/das28-edition-form";
import { computeDas28Sdai } from "parog-web/components/das28/utils/compute-das28";

import dayjs from "dayjs";
import baseEditionFormStyles from "parog-web/components/das28/base-edition-form/index.module.css";
import { computeSdaiDas28Activity } from "parog-web/components/das28/utils/compute-das28-activity";
import getAllDas28Jes from "parog-web/components/das28/utils/get-all-das28-jes";
import getLastBioExamInfos from "parog-web/components/das28/utils/get-last-bio-exam-infos";
import mostRecentJe from "parog-web/components/das28/utils/most-recent-je";
import Das28SdaiComputedJournalEvent from "parog-web/models/das28-sdai-computed-journal-event";
import { sortBy } from "parog-web/utils/sort";

interface MedicInfos {
  occurredAt: Date | undefined;
  medicFeeling: string;
}

export default class Das28SdaiEditionFormComponent extends Das28EditionFormComponent {
  static forcDisplayName = "Calculer le SDAI";
  static fullComponentId = "das28/das28-sdai-edition-form";
  static journalEventClass = Das28SdaiComputedJournalEvent;

  currentComputeDas28Function = computeDas28Sdai;
  currentComputeDAS28Activity = computeSdaiDas28Activity;

  specificDas28Properties = ["crp", "medicFeeling", "comments"];
  baseEditionFormStyles = baseEditionFormStyles;

  journalEventProperties = [
    ...this.specificDas28Properties,
    ...this.standardJournalEventProperties,
    ...this.sharedDas28Properties
  ];

  get lastBioExamsInfos() {
    //CRP
    const crpCode = "LOINC-1988-5";
    //get only bioExamsJE with crp
    return getLastBioExamInfos(this.patient, "crp", crpCode);
  }

  get lastCrpDate() {
    if (
      this.lastBioExamsInfos.crp != undefined &&
      this.changeset.get("crp") == +this.lastBioExamsInfos.crp / 10
    ) {
      return dayjs(this.lastBioExamsInfos.occurredAt).format(
        "[Dernière mesure le] DD/MM/YYYY"
      );
    }
    return "";
  }

  get lastMedicFeelingInfos(): MedicInfos {
    const lastDas28JesWithMedicFeeling = getAllDas28Jes(this.patient)
      .filter(je => je?.["medicFeeling"])
      .sort(sortBy("occurredAt", "desc"))[0];

    const lastJE = mostRecentJe(
      this.patient.lastPrFeelingEvaMedicDeclaredJournalEvent,
      lastDas28JesWithMedicFeeling
    );

    return {
      medicFeeling: lastJE?.["feeling"] || lastJE?.["medicFeeling"],
      occurredAt: lastJE?.occurredAt
    };
  }

  get lastMedicFeelingJeDate() {
    if (
      this.lastMedicFeelingInfos.medicFeeling != undefined &&
      this.changeset.get("medicFeeling") ==
        this.lastMedicFeelingInfos.medicFeeling
    ) {
      return dayjs(this.lastMedicFeelingInfos.occurredAt).format(
        "[Dernière mesure le] DD/MM/YYYY"
      );
    }
    return "";
  }

  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) {
      /**
       * We multiply it by 10 because shown CRP is in mg/dL, instead of mg/L
       */
      model.crp = this.lastBioExamsInfos.crp
        ? +this.lastBioExamsInfos.crp / 10
        : undefined;

      model.medicFeeling = this.lastMedicFeelingInfos?.medicFeeling;
    }
    return model;
  }
}
